export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games.vue?vue&type=template&id=50799408"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/games/games.vue?vue&type=template&id=50799408
// module id = 7c48
// module chunks = 0